module.exports = __webpack_public_path__ + "static/media/banner_logo.c97b0b94.png";